import DialogError from '~/components/dialog/error/DialogError.vue';
import DialogShare from '~/components/dialog/share/DialogShare.vue';
import DialogShareSponsor from '~/components/dialog/share/DialogShareSponsor.vue';
export const useShareSponsor = () => {
  const { t } = useI18n();
  const dialog = useDialogStore();
  const isOpening = ref<boolean>(false);
  const handleShareSponsor = async () => {
    if (isOpening.value) return;
    isOpening.value = true;
    const { result, error } = await useApiFetch(URI.Referral);
    isOpening.value = false;
    if (!error) {
      dialog.open(DialogShare, {
        iconHeader: 'sponsor',
        title: result.referFriend.title,
        label: '',
        shareText: result.referFriend.share.shareMessage,
        viewShareAvailable: markRaw({
          component: DialogShareSponsor,
          props: {
            banner: result.referFriend.banner.mediaUrl,
            code: result.referralCode,
          },
        }),
        viewShareIsNotAvailable: markRaw({
          component: DialogShareSponsor,
          props: {
            banner: result.referFriend.banner.mediaUrl,
            code: result.referralCode,
          },
        }),
      });
    } else {
      dialog.open(DialogError, {
        title: 'Oups',
        label: t('error.request'),
      });
    }
  };
  return {
    handleShareSponsor,
  };
};
